<div class="table-responsive">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    class="mat-elevation-z1 full-width-table"
  >
    <ng-container
      *ngFor="let dt of attrData; let i = index"
      [matColumnDef]="dt"
    >
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ namesColumns[i] }}
      </th>

      <td mat-cell *matCellDef="let element">
        {{ element[dt] }}
      </td>
    </ng-container>

    <ng-container matColumnDef="noData">
      <td
        mat-footer-cell
        *matFooterCellDef
        [colSpan]="attrData.length"
        style="text-align: center; padding: 2rem; color: #888"
      >
        <span>Sin datos para mostrar</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="attrData"></tr>
    <tr mat-row *matRowDef="let row; columns: attrData"></tr>

    <tr
      mat-footer-row
      *matFooterRowDef="['noData']"
      [hidden]="dataSource.data.length > 0"
    ></tr>
  </table>

  <mat-paginator
    *ngIf="showPagination"
    [pageSize]="5"
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
